import React, { useState, useEffect } from 'react';
import {
  Mic,
  Clock,
  Volume2,
  CreditCard,
  Code,
  Settings,
  User,
  LogOut,
} from 'lucide-react';

function Sidebar({ activeTab, onTabChange, user, onSignOut }) {
  const [isOpen, setIsOpen] = useState(window.innerWidth > 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const ADMIN_EMAIL = 'maazkhansgsits@gmail.com';
  const isAdmin = user?.email === ADMIN_EMAIL;

  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth <= 768;
      setIsMobile(isNowMobile);
      if (!isNowMobile) {
        setIsOpen(true); // Keep open on desktop
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sections = [
    {
      name: 'Home',
      items: [
        { id: 'generate', path: '/generate', label: 'Text To Speech', icon: Mic },
        { id: 'history', path: '/history', label: 'Generation History', icon: Clock },
        { id: 'voices', path: '/voices', label: 'Voice Library', icon: Volume2 },
      ]
    },
    {
      name: 'Platform',
      items: [
        { id: 'add-credits', path: '/add-credits', label: 'Add Credits', icon: CreditCard },
        { id: 'api-access', path: '/api-access', label: 'API Access', icon: Code },
      ]
    },
    ...(isAdmin ? [{
      name: 'Admin',
      items: [
        { id: 'admin-voices', path: '/admin-voices', label: 'Manage Voices', icon: Settings },
      ]
    }] : [])
  ];

  return (
    <>
      {/* Mobile Toggle */}
      {isMobile && !isOpen && (
        <button className="sidebar-toggle" onClick={() => setIsOpen(!isOpen)}>
          ☰
        </button>
      )}

      {/* Sidebar */}
      {isOpen && (
        <div className="sidebar">
        {/* Header */}
        <div className="sidebar-header">
          <div className="sidebar-header-content">
            <img src="/logo.png" alt="Stick Audio Logo" className="logo-image" />
            <h2>Stick Audio</h2>
          </div>
          {isMobile && (
            <button className="close-btn" onClick={() => setIsOpen(false)}>✕</button>
          )}
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {sections.map((section) => (
            <div key={section.name} className="nav-section">
              <div className="nav-section-title">{section.name}</div>
              {section.items.map((item) => (
                <button
                  key={item.id}
                  className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
                  onClick={() => {
                    onTabChange(item.path);
                    if (isMobile) {
                      setIsOpen(false); // Close sidebar on mobile after selection
                    }
                  }}
                >
                  <span className="nav-icon">
                    <item.icon size={20} strokeWidth={2} />
                  </span>
                  <span className="nav-label">{item.label}</span>
                </button>
              ))}
            </div>
          ))}
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">
          {user && (
            <>
              <button
                className="nav-item"
                onClick={() => {
                  onTabChange('/profile');
                  if (isMobile) {
                    setIsOpen(false);
                  }
                }}
              >
                <span className="nav-icon">
                  <User size={20} strokeWidth={2} />
                </span>
                <span className="nav-label">Account Settings</span>
              </button>
              <button
                className="nav-item"
                onClick={() => {
                  onSignOut();
                  if (isMobile) {
                    setIsOpen(false);
                  }
                }}
              >
                <span className="nav-icon">
                  <LogOut size={20} strokeWidth={2} />
                </span>
                <span className="nav-label">Sign Out</span>
              </button>
            </>
          )}
        </div>
        </div>
      )}

      {/* Overlay for mobile */}
      {isMobile && isOpen && <div className="sidebar-overlay" onClick={() => setIsOpen(false)} />}
    </>
  );
}

export default Sidebar;
